module.exports = __webpack_public_path__ + "img/vegetable-radicchio-190x100.479f2bfd.jpg";